import React from 'react'

import Layout from '../components/layout.js'
import { SEO } from '../components/seo.js'
import { Button, Typography } from '@tunasong/ui-lib'

export const Head = () => <SEO title="401: Not authorized" />

/**
 * AuthGuard's fallback when a stored session couldn't be refreshed: offline, or a transient failure (GH #1469).
 * The session is kept, so a reload or a reconnect recovers. This used to read "Authorizing..." over a spinner
 * that never ended (first-run audit).
 */
const NotAuthorizedPage = () => (
  <Layout>
    <div role="alert">
      <Typography variant="subtitle1" component="p">
        Couldn&apos;t reach Tunasong
      </Typography>
      <Typography variant="body2" component="p">
        You&apos;re still signed in. Check your connection, then try again.
      </Typography>
    </div>
    <Button onClick={() => window.location.reload()}>Try again</Button>
  </Layout>
)

export default NotAuthorizedPage
